/**
 * Enum pour les noms des catégories racines principales
 */
export enum RootCategoryNames {
    PRODUCTS = 'PRODUCTS',
    RECIPES = 'RECIPES',
    REJO = 'REJO', // La racine absolue (si nécessaire)
    PRODUCTS_FR = 'PRODUITS',
    PRODUCTS_NL = 'PRODUCTEN',
    RECIPES_FR = 'RECETTES',
    RECIPES_NL = 'RECEPTEN'
}

/**
 * Type union pour une meilleure sécurité de type
 */
export type RootCategoryName =
    | RootCategoryNames.PRODUCTS
    | RootCategoryNames.RECIPES
    | RootCategoryNames.PRODUCTS_FR
    | RootCategoryNames.PRODUCTS_NL
    | RootCategoryNames.RECIPES_FR
    | RootCategoryNames.RECIPES_NL;

/**
 * Vérifie si une chaîne correspond à une catégorie racine valide
 */
export const isValidRootCategory = (categoryName: string | undefined): categoryName is RootCategoryName => {
    if (!categoryName) {
        return false;
    }
    const upperCaseName = categoryName.toUpperCase();
    return (
        upperCaseName === RootCategoryNames.PRODUCTS ||
        upperCaseName === RootCategoryNames.RECIPES ||
        upperCaseName === RootCategoryNames.PRODUCTS_FR ||
        upperCaseName === RootCategoryNames.PRODUCTS_NL ||
        upperCaseName === RootCategoryNames.RECIPES_FR ||
        upperCaseName === RootCategoryNames.RECIPES_NL
    );
};

/**
 * Vérifie si c'est la catégorie Products
 */
export const isProductsCategory = (categoryName: string | undefined): boolean => {
    if (!categoryName) {
        return false;
    }
    return (
        categoryName.toUpperCase() === RootCategoryNames.PRODUCTS ||
        categoryName.toUpperCase() === RootCategoryNames.PRODUCTS_FR ||
        categoryName.toUpperCase() === RootCategoryNames.PRODUCTS_NL
    );
};

/**
 * Vérifie si c'est la catégorie Recipes
 */
export const isRecipesCategory = (categoryName: string | undefined): boolean => {
    if (!categoryName) {
        return false;
    }
    return (
        categoryName.toUpperCase() === RootCategoryNames.RECIPES ||
        categoryName.toUpperCase() === RootCategoryNames.RECIPES_FR ||
        categoryName.toUpperCase() === RootCategoryNames.RECIPES_NL
    );
};

/**
 * Retourne la liste des catégories racines valides
 */
export const getValidRootCategories = (): RootCategoryName[] => {
    return [
        RootCategoryNames.PRODUCTS,
        RootCategoryNames.RECIPES,
        RootCategoryNames.PRODUCTS_FR,
        RootCategoryNames.PRODUCTS_NL,
        RootCategoryNames.RECIPES_FR,
        RootCategoryNames.RECIPES_NL
    ];
};
